module.exports = __webpack_public_path__ + "img/top-left.c50fa89.svg";